<colgroup>
   <col *ngFor="let c of columnDefs" 
      [style.width]="c.width ? c.width+'rem' : 'auto'" 
      [style.minWidth]="c.width ? c.width+'rem' : 'auto'" 
      [hidden]="!c.visible" 
   />
   <col *ngIf="actionDefs.length" 
      [class]="'actions'"
      [style.width]="actionsColumnWidth ? actionsColumnWidth+'rem' : 'auto'" 
      [style.minWidth]="actionsColumnWidth ? actionsColumnWidth+'rem' : 'auto'" 
   />
</colgroup>
<thead *ngIf="!hideHeader">
   <tr [ngClass]="{'configurableColumns': configurableColumns}">
      <ng-container *ngFor="let c of columnDefs; let i = index">
         <th *ngIf="c.type==ColType.panelToggle" class="table-row-expand-btn">&nbsp;</th>
         <th *ngIf="c.type!==ColType.panelToggle" 
            [class.sortable]="sortable && c.sortable" 
            [class.sorted]="c.sorted"
            [class.asc]="c.sorted && sortDirection=='+'" 
            [class.desc]="c.sorted && sortDirection=='-'"
            [class.sizeable]="c.sizeable"
            [class.moveable]="c.moveable" 
            [class.dragging]="c.moveable && dragSourceIndex === i"
            [class.drag-over]="c.moveable && dragOverIndex === i" 
            [hidden]="!c.visible"
            [style.text-align]="getTextAlign(c)"
            [attr.draggable]="c.moveable ? 'true' : null" 
            (dragstart)="c.moveable && onDragStart(i)"
            (dragover)="c.moveable && onDragOver($event, i)" 
            (drop)="c.moveable && onDrop(i)"
            (dragend)="c.moveable && onDragEnd()" 
            (mouseup)="onSortClick(c)">
             <i *ngIf="c.iconClassname" class="text-muted {{c.iconClassname}}"></i>{{c.header}}
             <span *ngIf="c.sizeable" class="resize-handle" (mousedown)="onResizeStart($event, i)"></span>
         </th>
      </ng-container>
      <th *ngIf="actionDefs.length" class="actions"></th>
   </tr>
</thead>